import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "material-react-toastify";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router } from "react-router-dom";

import "./styles/css/index.css";
import App from "./components/App";
import reportWebVitals from "./functionUtilities/reportWebVitals";
import { store } from "./redux/store/reduxStore";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store.store}>
      <PersistGate loading={null} persistor={store.persistor}>
        <HelmetProvider>
          <Router>
            <App />
          </Router>
        </HelmetProvider>
      </PersistGate>
    </Provider>
    <ToastContainer
      position="top-center"
      autoClose={20000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnHover
      draggable
    />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
